if (!customElements.get("shop-article")) {
  class ShopArticle extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector(":scope > .grid, :scope > div");
      if (!container) return;

      const raw = this.dataset.articles || "";
      const handles = Array.from(
        new Set(
          raw
            .split("|")
            .map((s) => s.trim())
            .filter(Boolean)
        )
      );
      if (!handles.length) return;

      const prefix = this.localePrefix();
      const listName = this.dataset.listName || "Shop this Article";
      const ga4Items = [];

      const fetchOne = async (handle, index) => {
        const base = `${prefix}/products/${encodeURIComponent(handle)}`;

        try {
          const jsonRes = await fetch(`${base}.js`, {
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });

          if (!jsonRes.ok) {
            return null;
          }

          const productData = await jsonRes.json();

          const sectionRes = await fetch(`${base}?section_id=product-item`, {
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });

          if (!sectionRes.ok) return null;

          const html = await sectionRes.text();
          if (!html.trim()) return null;

          var variant = productData.variants && productData.variants[0];
          ga4Items.push({
            item_id: (variant && variant.sku) || String(productData.id),
            item_name: productData.title,
            item_brand: productData.vendor,
            price: productData.price / 100,
            index: index,
            item_list_id: "shop-this-article",
            item_list_name: listName,
          });

          return html;
        } catch (e) {
          console.error("Section fetch failed for", handle, e);
          return null;
        }
      };

      const run = async () => {
        const concurrency = 4;
        let i = 0;

        const next = async () => {
          if (i >= handles.length) return;
          const idx = i++;
          const html = await fetchOne(handles[idx], idx);
          if (html) {
            container.insertAdjacentHTML("beforeend", html);
          }
          await next();
        };

        await Promise.all(
          Array.from({ length: Math.min(concurrency, handles.length) }, next)
        );

        if (ga4Items.length && typeof gtag === "function") {
          // gtag("event", "view_item_list", {
          //   item_list_id: "shop-this-article",
          //   item_list_name: listName,
          //   items: ga4Items,
          // });
          window.LeafCustomEvents.publish("view_item_list", {
            item_list_id: "shop-this-article",
            item_list_name: listName,
            items: ga4Items,
          });
        }
      };

      run();
    }

    localePrefix() {
      const m = location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
      return m ? `/${m[1]}` : "";
    }
  }

  customElements.define("shop-article", ShopArticle);
}
